(function () {
  let navbar, mainNav, leftNav, blur

  function isDesktop () {
    return window.innerWidth >= 1024
  }

  function handleActiveChange (event) {
    const isActive = event.detail[0]

    toggleAll(isActive)
  }

  function toggleAll (isActive) {
    toggleLeftNav(isActive)
    toggleNavbar(isActive)
    toggleBlur(isActive)
  }

  function toggleLeftNav (active) {
    if (!leftNav) {
      return
    }

    const leftActiveClass = 'is-active'

    if (active) {
      if (!leftNav.classList.contains(leftActiveClass)) {
        leftNav.classList.add(leftActiveClass)
      }
    } else {
      if (leftNav.classList.contains(leftActiveClass)) {
        leftNav.classList.remove(leftActiveClass)
      }
    }
  }

  function toggleBlur (active) {
    if (!blur) {
      return
    }

    const blurActiveClass = 'is-active'

    if (active) {
      if (!blur.classList.contains(blurActiveClass)) {
        blur.classList.add(blurActiveClass)
      }
    } else {
      if (blur.classList.contains(blurActiveClass)) {
        blur.classList.remove(blurActiveClass)
      }
    }
  }

  function toggleNavbar (active) {
    if (!navbar) {
      return
    }

    navbar.toggleAttribute('is-main-menu-active', active)
  }

  function handleAnyActiveChange (event) {
    const isActive = event.detail[0]
    if (isActive && !isDesktop()) {
      document.documentElement.classList.add('is-clipped')
    } else {
      document.documentElement.classList.remove('is-clipped')
    }
  }

  function handleSwitch (event) {
    if (event && Array.isArray(event.detail) && event.detail[0] && event.detail[0].unsecureId) {
      window.location.href = '/accounts/manager/switch?account_id=' + event.detail[0].unsecureId
    } else {
      console.error('Invalid event in handleSwitch()!', event)
    }
  }

  function handleLogout () {
    window.location.href = '/logout'
  }

  function handleHelp (event) {
    // eslint-disable-next-line no-undef
    if (Intercom) {
      // eslint-disable-next-line no-undef
      Intercom('show')
    } else {
      console.error('Intercom not found in handleHelp()!')
    }
  }

  function handleClose () {
    toggleAll(false)
  }

  function run() {
    navbar = document.querySelector('#ld-main__navbar')
    mainNav = document.querySelector('#ld-main__main-nav')
    leftNav = document.querySelector('#ld-main__left-nav')
    blur = document.querySelector('#ld-main__blur')

    if (navbar) {
      navbar.addEventListener('main-active-change', handleActiveChange)
      navbar.addEventListener('any-active-change', handleAnyActiveChange)
      navbar.addEventListener('logout', handleLogout)
      navbar.addEventListener('switch', handleSwitch)
      navbar.addEventListener('help', handleHelp)
    } else {
      console.warn('navbar not found in ld_compatibility')
    }

    if (mainNav) {
      mainNav.addEventListener('help', handleHelp)
      mainNav.addEventListener('close', handleClose)
    } else {
      console.warn('mainNav not found in ld_compatibility')
    }

    if (blur) {
      blur.addEventListener('click', handleClose)
    } else {
      console.warn('blur not found in ld_compatibility')
    }

    if (!isDesktop()) {
      toggleAll(false)
    }
  }

  if (document.readyState !== 'loading') {
    run()
    return
  }
  document.addEventListener('DOMContentLoaded', run)
// eslint-disable-next-line no-undef
})()
